@if (showCombobox) {
<div class="pds-multi-select-autocomplete__overlay" (click)="handleOverlayClick()"></div>
} @if (sourceData) {
<div class="pds-multi-select-autocomplete">
  <div class="pds-multi-select-autocomplete__input-wrapper" [class.--is-disabled]="disabled" (click)="handleSearchFocusEvent()">
    @for (item of values(); track item.id) {
    <div class="pds-multi-select-autocomplete__selected-item">
      <span>{{ item.label }}</span>
      <button type="button" class="pds-multi-select-autocomplete__selected-item__remove" [class.--is-disabled]="disabled" [disabled]="disabled" (click)="removeItem(item, $event)" aria-label="Remover item">
        <span class="icon">close</span>
      </button>
    </div>
    } @empty {
    <div class="pds-multi-select-autocomplete__placeholder">
      {{ placeholder() }}
    </div>
    }
  </div>

  @if (showCombobox) {
  <div class="pds-multi-select-autocomplete__combobox" role="combobox">
    @if (historyData && historyData.data?.length) {
    <div class="pds-multi-select-autocomplete__combobox__list">
      <h4 class="pds-multi-select-autocomplete__combobox__list__title">Histórico</h4>
      <ul>
        @for (item of historyData.data; track item.id) {
        <li class="pds-multi-select-autocomplete__combobox__list__item" role="option" [attr.aria-selected]="isItemSelected(item)" data-value="{{ item.id }}" (click)="selectItem(item)" [class.--selected]="isItemSelected(item)">
          {{ item.label }}
          @if (isItemSelected(item)) {
          <span class="icon">check</span>
          }
        </li>
        }
      </ul>
    </div>
    }

    <div class="pds-multi-select-autocomplete__combobox__search">
      <h4>Filtro</h4>
      <input type="text" #searchInput [disabled]="disabled" [placeholder]="placeholder()" (keydown)="handleSearchKeydownEvent($event)" aria-label="Buscar itens" />
    </div>

    <div class="pds-multi-select-autocomplete__combobox__list">
      <h4 class="pds-multi-select-autocomplete__combobox__list__title">Resultados</h4>

      @if (sourceData.loading) {
      <div class="pds-multi-select-autocomplete__combobox__list__label">carregando...</div>
      } @if (sourceData.failure) {
      <div class="pds-multi-select-autocomplete__combobox__list__label">Ocorreu um erro ao obter os resultados.</div>
      } @if (sourceData.data && !sourceData.data.length) {
      <div class="pds-multi-select-autocomplete__combobox__list__label">Nenhum resultado encontrado.</div>
      } @if (!sourceData.failure && !sourceData.loading && !sourceData.data) {
      <div class="pds-multi-select-autocomplete__combobox__list__label">{{ noSearchMessage() }}</div>
      } @if (sourceData.data && sourceData.data.length > 0) {
      <ul>
        @for (item of sourceData.data; track item.id) {
        <li class="pds-multi-select-autocomplete__combobox__list__item" role="option" [attr.aria-selected]="isItemSelected(item)" data-value="{{ item.id }}" (click)="selectItem(item)" [class.--selected]="isItemSelected(item)">
          <span class="icon">{{ isItemSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</span>
          <div class="pds-multi-select-autocomplete__combobox__list__item__content">
            <span>{{ item.label }}</span>
            <span class="pds-multi-select-autocomplete__combobox__list__item__content__description">{{ item.description }}</span>
          </div>
        </li>
        }
      </ul>
      }
    </div>
  </div>
  }
</div>
}
